var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTlntPro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1792.146,
    height: 217.632,
    viewBox: "0 0 1792.146 217.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-1248.223 -564.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M147.356,67h195V96.93H264.092V278.587H225.923V96.93H147.356Z",
    transform: "translate(1100.868 500.584)",
    fill: "#f58634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M212.792,67V248.668H313.755v29.919H174.919V67Z",
    transform: "translate(1306.785 500.584)",
    fill: "#f58634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M361.919,265.889V67H398.2V278.587H333.517L231.918,79.7V278.587H195.629V67h64.692Z",
    transform: "translate(1461.506 500.584)",
    fill: "#f58634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M224.087,67H419.076V96.93H340.823V278.587H302.654V96.93H224.087Z",
    transform: "translate(1674.11 500.584)",
    fill: "#f58634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M259.77,67h94.97q76.984,0,76.988,70.727,0,72.244-78.246,72.24H333.6l-19.562-29.922H350.96q43.22,0,43.226-41.714,0-41.4-41.336-41.408H297.636V278.586H259.77Z",
    transform: "translate(1940.693 500.586)",
    fill: "#f58634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M395.216,197.885l79.2,55.915-3.784,24.786H434.344l-72.886-79.194h-.947l-23.979-26.9H371.87q46.693,0,46.7-38.388,0-37.173-42.908-37.178h-52.7V278.586H285.1V67h93.08Q455.8,67,455.8,131.685q0,57.436-60.583,66.2",
    transform: "translate(2129.916 500.584)",
    fill: "#f58634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M521.327,258.281q-29.024,26-90.866,26t-90.871-26q-28.718-26.3-28.716-82.817,0-56.824,28.716-82.519,29.024-26.3,90.871-26.3t90.866,26.3q29.03,26,29.03,82.519t-29.03,82.817M368.615,233.8q18.619,17.535,61.845,17.535T491.986,233.8q18.931-17.828,18.928-58.332t-18.928-58.039Q473.362,99.6,430.46,99.593q-42.6,0-61.845,17.833Q350,135.266,350,175.464q0,40.506,18.614,58.332",
    transform: "translate(2322.478 497.917)",
    fill: "#f58634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M341.9,66.907H394.76V78.292H375.6v48.086H361.057V78.292H341.9Zm113.164,0h21.643l9.4,59.47H472.271l-7.982-49.445-13.126,49.445h-17.74L420.3,76.932l-8.156,49.445H398.485l9.4-59.47h21.461l12.947,50.3Z",
    transform: "translate(2554.261 499.869)",
    fill: "#f58634"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTlntPro);
export default __webpack_public_path__ + "static/media/tlnt-pro.fd181e86bafe9ef5d8ebbb33fb00ff39.svg";
export { ForwardRef as ReactComponent };